import { makeSnapshotAction } from '@cotera/client/v0/columns/common-actions/snapshot-column.action';
import { SaveToolCallColumnAction } from './save-tool-call-column.action';
import { ToolCallModel } from '../tool-call.model';

export class ToolCallColumnSnapshotAction extends makeSnapshotAction(
  'Run Tool Call Column',
  ToolCallModel,
  SaveToolCallColumnAction
) {}
